import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";

export class Relationship extends ODataSelect
{
    public Id = '';
    public Name = '';
    public Description = '';
    public IsEnabled = false;
    public Primary2SecondaryRelation = '';
    public Secondary2PrimaryRelation = '';
    public '@odata.etag' = '';

    public init(response: any, nodeId: number): ODataSelect
    {
        Object.assign(this, response);
        this.IsEnabled = TypeHelper.toBoolean(response.IsEnabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}
